module.exports = {
	"id": "PW",
	"name": "Palau",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.020418,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.013612,
			"11": 0.251822,
			"12": null,
			"13": 0.006806,
			"14": 0.020418,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.054448,
			"19": 0.040836,
			"20": null,
			"21": 0.006806,
			"22": null,
			"23": 0.020418,
			"24": 0.013612,
			"25": 0.020418,
			"26": 0.605734,
			"27": null,
			"28": 0.387942,
			"29": 0.040836,
			"30": 0.176956,
			"31": 0.122508,
			"32": 0.013612,
			"33": 0.115702,
			"34": null,
			"35": 0.06806,
			"36": 0.013612,
			"37": 0.013612,
			"38": 0.03403,
			"39": 0.095284,
			"40": 0.149732,
			"41": 0.013612,
			"42": 0.013612,
			"43": null,
			"44": 0.027224,
			"45": 0.571704,
			"46": 0.401554,
			"47": 0.088478,
			"48": 0.558092,
			"49": 1.29314,
			"50": 0.564898,
			"51": 0.353912,
			"52": 0.626152,
			"53": 16.74276,
			"54": 3.144372,
			"55": 0.129314,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.217792,
			"4": 0.088478,
			"5": 0.006806,
			"6": 0.020418,
			"7": null,
			"8": 0.020418,
			"9": null,
			"10": 0.163344,
			"11": 0.061254,
			"12": 0.027224,
			"13": null,
			"14": 0.156538,
			"15": 0.047642,
			"16": 0.51045,
			"17": null,
			"18": 0.394748,
			"19": 0.013612,
			"20": 0.13612,
			"21": 0.013612,
			"22": null,
			"23": 0.006806,
			"24": 0.061254,
			"25": null,
			"26": 0.231404,
			"27": 0.006806,
			"28": 0.06806,
			"29": 0.047642,
			"30": 0.040836,
			"31": 0.074866,
			"32": 0.156538,
			"33": 0.027224,
			"34": 0.592122,
			"35": 0.503644,
			"36": 1.170632,
			"37": 0.449196,
			"38": 0.047642,
			"39": 0.176956,
			"40": 1.749142,
			"41": 0.190568,
			"42": 0.03403,
			"43": 2.58628,
			"44": 0.367524,
			"45": 1.3612,
			"46": 1.014094,
			"47": 3.314522,
			"48": 0.803108,
			"49": 6.32958,
			"50": 0.728242,
			"51": 0.088478,
			"52": 0.013612,
			"3.5": null,
			"3.6": 0.197374
		},
		"opera": {
			"9": null,
			"11": 0.027224,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.013612,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.020418,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.013612,
			"38": null,
			"39": null,
			"40": 0.040836,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": 0.17015,
			"11.5": null,
			"11.6": 0.006806,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.013612,
			"7": null,
			"8": 0.115702,
			"9": 0.047642,
			"10": 0.245016,
			"3.1": 0.006806,
			"3.2": null,
			"5.1": 0.013612,
			"6.1": null,
			"7.1": null,
			"9.1": 0.30627
		},
		"ios_saf": {
			"8": 0,
			"10": 1.54367003997,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0416001213572,
			"8.1-8.4": 0.0768544614904,
			"9.0-9.2": 0.0366645137386,
			"9.3": 0.559368863447
		},
		"android": {
			"3": 0,
			"4": 0.0379566046512,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0047445755814,
			"4.1": 0.136914895349,
			"4.2-4.3": 0.342287238372,
			"4.4": 0.784888360465,
			"4.4.3-4.4.4": 0.791666325581
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 1.49732,
			"9": 1.490514,
			"10": 1.892068,
			"11": 4.981992,
			"5.5": null
		},
		"op_mob": {
			"0": 0.275553627785,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00765426743847
		},
		"edge": {
			"12": 0.6806,
			"13": 0.558092,
			"14": 0.095284
		},
		"ie_mob": {
			"10": 0.0195238873239,
			"11": 0.0794901126761
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 1.56506
		},
		"and_uc": {
			"0": 8.588666
		},
		"op_mini": {
			"0": 3.71248610478
		},
		"and_chr": {
			"0": 14.126128
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 96.122262
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PW.json
 ** module id = 629
 ** module chunks = 0
 **/